// extracted by mini-css-extract-plugin
module.exports = {"AnnualSummary":"AnnualSummary_AnnualSummary__SABYn","winAnnua":"AnnualSummary_winAnnua__uE9EJ","appPage":"AnnualSummary_appPage__pPvcQ"};